var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://oss.mcloud.moveclub.cn/2025/mv/Q%26A_h5.png"}}),_c('QuestionForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }